import { useCallback } from 'react';
import { useAuth } from '@clerk/react';

export const useAccessToken = () => {
  const { getToken: clerkGetToken } = useAuth();

  const getToken = useCallback(async () => {
    const token = await clerkGetToken();
    if (!token) {
      throw new Error('No access token available');
    }
    return token;
  }, [clerkGetToken]);

  return { getToken };
};
